import { iniciais } from '@entregas/core';
import css from './LogoDaLoja.module.css';

interface Props {
  nome: string;
  /** Data URL da logo; null = as iniciais num quadrado neutro (como nos apps). */
  logo: string | null;
  /** Altura da caixa em px (e o lado do quadrado das iniciais). */
  altura: number;
  /** Logo larga encolhe inteira até aqui (nunca corta: sobra fundo neutro em volta). */
  larguraMax?: number;
  /** Texto alternativo; sem ele a imagem é decorativa (o nome da loja já está ao lado). */
  rotulo?: string;
  className?: string;
}

/**
 * A logo da loja (painel, link do cliente, Configurações). Caixa de altura fixa e largura livre até
 * `larguraMax`, com `object-fit: contain`: a logo de 453×325 da A3 aparece inteira, sem corte.
 */
export function LogoDaLoja({
  nome,
  logo,
  altura,
  larguraMax = altura * 3,
  rotulo,
  className,
}: Props) {
  if (logo) {
    return (
      <img
        src={logo}
        alt={rotulo ?? ''}
        className={[css.imagem, className].filter(Boolean).join(' ')}
        style={{ height: altura, maxWidth: larguraMax }}
        decoding="async"
      />
    );
  }
  return (
    <span
      className={[css.iniciais, className].filter(Boolean).join(' ')}
      style={{ width: altura, height: altura, fontSize: Math.round(altura * 0.36) }}
      aria-hidden="true"
    >
      {iniciais(nome)}
    </span>
  );
}
